export default "__VITE_ASSET__7e0c336b__"